import { sereniApi } from "../config/axiosConfigs";
import { AccountingEntity } from "../models/AccountingEntity";
import { FloatingStock } from "../models/FloatingStock";
import { FuneralHome } from "../models/FuneralHome";
import { Product } from "../models/Product";
import { FloatingStockRequest } from "../models/requests/FloatingStockRequest";
import { Settings } from "../models/Settings";
import { StockData } from "../models/StockData";
import { Supplier } from "../models/Supplier";

export const SereniApi = {
  fetchAllFuneralhomes: async function (): Promise<FuneralHome[]> {
    const response = await sereniApi.request({
      url: "/funeralhomes",
      method: "GET",
      params: {},
      data: {},
    });

    return response.data;
  },

  fetchAllGroupedFuneralhomes: async function (): Promise<AccountingEntity[]> {
    const response = await sereniApi.request({
      url: "/funeralhomes-grouped",
      method: "GET",
      params: {},
      data: {},
    });

    return response.data;
  },

  fetchProducts: async function (supplierId: string): Promise<Product[]> {
    let url = "/products/" + supplierId;
    const response = await sereniApi.request({
      url: url,
      method: "GET",
      params: {},
      data: {},
    });

    return response.data;
  },

  fetchSuppliers: async function (): Promise<Supplier[]> {
    const response = await sereniApi.request({
      url: "/suppliers",
      method: "GET",
      params: {},
      data: {},
    });

    return response.data;
  },

  fetchSettings: async function (): Promise<Settings> {
    const response = await sereniApi.request({
      url: "/settings",
      method: "GET",
      params: {},
      data: {},
    });

    return response.data;
  },

  fetchFloatingStock: async function (
    costCode: string,
    stocks: StockData[]
  ): Promise<FloatingStock[]> {
    let request: FloatingStockRequest = {
      COSTCODE: costCode,
      PRODUCTCODES: [],
    };

    stocks.forEach((stock) => {
      request.PRODUCTCODES.push(stock.no);
    });

    const response = await sereniApi.request({
      url: "/floatingstock/find",
      method: "POST",
      params: {},
      data: request,
    });

    return response.data;
  },
};
